import { launch } from "./Launch";
var sdk = { launch: launch };
export { sdk as CasinoSlimSdk };
//# sourceMappingURL=index.js.map